export const MY_TRANSFER_AVAILABILITY_SUCCESS = 'GET_MY_TRANSFER_AVAILABILITY_SUCCESS';
export const MY_TRANSFER_AVAILABILITY_FAIL = 'GET_MY_TRANSFER_AVAILABILITY_FAIL';

export const MY_TRANSFER_SELECTED_VEHICLE = 'MY_TRANSFER_SELECTED_VEHICLE'

export const RESET_MYTRANSFER = 'RESET_MYTRANSFER'